import { Card, Stack, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { setActiveMarkerId, setHighlightedPlaceId } from "../../../store";
import { COLOR_GRAY, COLOR_PRIMARY } from "../../../utils/styles";
import { convertHoursOfOperation, getDayOfTheWeek, isOpenNow } from "../../../utils/dataFormatter";
import OpenNow from "../../common/OpenNow";

function PlaceListDetail(props) {
  // check if this current item is the same as the highlighted_place_id
  const dispatch = useDispatch();
  const highlighted_place_id = useSelector(
    (state) => state.place.highlighted_place_id,
  );
  const isHighlighted = props.placeData.placeId === highlighted_place_id;

  const hoursOfOperation = props.placeData.hoursOfOperation ? convertHoursOfOperation(props.placeData.hoursOfOperation) : null;

  return (
    <Card
      onMouseEnter={() =>
        dispatch(setHighlightedPlaceId(props.placeData.placeId))
      }
      onMouseLeave={() => dispatch(setHighlightedPlaceId(null))}
      onClick={() => dispatch(setActiveMarkerId(props.placeData.placeId))}
      sx={{
        textAlign: "left",
        backgroundColor: "white",
        border: "none",
        borderBottom: 0.5,
        borderRadius: 0,
        borderColor: COLOR_GRAY,
        boxShadow: isHighlighted ? "md" : "none",
      }}
    >
      <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <Stack sx={{ width: "330px" }}>
          <Typography
            level="title-lg"
            sx={{
              "&::selection": {
                backgroundColor: COLOR_PRIMARY,
              },
            }}
          >
            {props.placeData.name}
          </Typography>
          <Typography
            level="body-xs"
            sx={{
              "&::selection": {
                backgroundColor: COLOR_PRIMARY,
              },
              textDecoration: "none",
              color: "inherit",
              transition: "color 0.3s ease, text-decoration 0.3s ease",
              "&:hover": {
                textDecoration: "underline",
              },
              cursor: "pointer",
            }}
            onClick={() => {
              let encodedAddress = encodeURIComponent(
                props.placeData.formattedAddress,
              );
              window.open(
                `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&query_place_id=${props.placeData.placeId}`,
              );
            }}
          >
            {props.placeData.formattedAddress}
          </Typography>
          <Typography
            level="body-xs"
            sx={{
              "&::selection": {
                backgroundColor: COLOR_PRIMARY,
              },
              textDecoration: "none",
              color: "inherit",
              transition: "color 0.3s ease, text-decoration 0.3s ease",
              "&:hover": {
                textDecoration: "underline",
              },
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = `tel:${props.placeData.formattedPhoneNumber ? props.placeData.formattedPhoneNumber : null}`
            }}
          >
            {props.placeData.formattedPhoneNumber}
          </Typography>
          {hoursOfOperation && (
            <Stack direction="row" spacing={0.8} sx={{
              justifyContent: "flex-start",
            }}>
              <OpenNow isOpen={isOpenNow(props.placeData.hoursOfOperation)} />
              <Typography level="body-sm">•</Typography>
              <Typography level="body-sm">{getDayOfTheWeek()}</Typography>
              <Typography level="body-sm">{hoursOfOperation[getDayOfTheWeek()].join(", ")}</Typography>
            </Stack>
          )}
        </Stack>
        <Stack sx={{ alignItems: "center", width: "70px" }}>
          <Typography level="h3"
            sx={{
              "&::selection": {
                backgroundColor: COLOR_PRIMARY,
              },
            }}
          >
            ${props.placeData.corkageFee}
          </Typography>
          <Typography level="body-xs">per bottle</Typography>
          {props.placeData.bottleLimit && (
            <Typography level="body-xs">max: {props.placeData.bottleLimit}</Typography>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}

export default PlaceListDetail;
